<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Q39tJp/tc-custom/9781625670472.jpg?1703426607560" alt="This image is the cover for the book Wed and Buried, A Laura Fleming Mystery"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wed and Buried, A Laura Fleming Mystery
      </h1>
      <p class="bookDescription body article font2">
        <b>A Southern smalltown wedding attracts well-wishers—and a killer—in this cozy mystery by the <i>New York Times</i>–bestselling author of <i>Mad as the Dickens</i>.</b><br/><br/>Romance is in the air—and so is murder—in the eighth in Agatha Award-winning author Toni L.P. Kelner’s small-town Southern mystery series.<br/><br/>Laura Fleming knows that love plays by its own rules. After all, she did the unthinkable and married a Yankee. But even she’s shocked to hear that her indomitable Aunt Maggie, a spinster closer to eighty than seventy, has eloped with Big Bill Walters. Laura, her husband Richard, and their baby daughter hightail it home, where Laura discovers the real motive behind Aunt Maggie’s marriage. Someone is trying to kill Big Bill, and Aunt Maggie plans to stick close enough to find the culprit—with Laura’s help.<br/><br/>Big Bill is Byerly’s wealthiest businessman, so it’s little surprise certain folks have a beef with him. In fact, there’s a stack of threatening letters going back decades to wade through. Claims of land theft and worker injury abound, plus Aunt Maggie’s one-time beau, Pudd’nhead Wilson, is back in town. Innocents are getting caught in the crossfire, and Laura concocts a risky plan to lure the killer into the open. But she’ll need to keep Aunt Maggie safe too, or Byerly’s oldest newlywed will soon be its newest widow . . .<br/><br/><b>Praise for <i>Wed and Buried</i></b><br/><br/><b>“The Southern milieu with its friendly warmth and innumerable relatives belies the hatred and tensions smoldering beneath the surface in Kelner's eighth airy Laura Fleming cozy. . . . Good humor abounds amid the murder and mayhem in this sprawling family.” —<i>Publishers Weekly</i></b><br/><br/><b>“Decidedly homey characters, country charm, and upbeat tone.” —<i>Library Journal</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Toni L. P. Kelner
      </h2>
      
      <p class="authorDescription body article">Toni L.P. Kelner is the author of the Laura Fleming mysteries and the &quot;Where Are They Now?&quot; series. She is also the author of numerous short stories, and co-edits bestselling urban fantasy anthologies with Charlaine Harris. Her short stories have been nominated for the Anthony, the Macavity, and the Derringer awards, and she has won the Agatha Award. Under her pseudonym Leigh Perry, she writes the Family Skeleton mystery series. Visit her at <a href="http://www.ToniLPKelner.com">www.ToniLPKelner.com</a> and <a href="http://www.LeighPerryAuthor.com">www.LeighPerryAuthor.com</a>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      JABberwocky Literary Agency, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2fd92d1d